import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class BranchManagerDashboardService {

  private baseURL = environment.apiURL;

  constructor(private http: HttpClient, private errorHandler: ConfigErrorHandler) { }

  /**
   * Count units in supplier stock
   * @returns Array
   */
  public countUnitsInSupplierStock():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/count-units-in-supplier-stock`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

   /**
   * Count units en route
   * @returns Array
   */
  public countUnitsEnroute():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/count-units-en-route`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Count vehicles at CFS
   * @returns Array
   */
  public countUnitsAtCFS():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/count-units-at-cfs`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Count units sold within the current week
   * @returns Array
   */
  public countUnitsSoldThisWeek():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/count-units-sold-this-week`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get weekly sales summary
   * @returns Array
   */
   public getWeeklySalesSummary(salesPeriodFilter:string):Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/get-weekly-sales-summary/${salesPeriodFilter}`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get incoming transfers
   * @returns Array
   */
   public getIncomingTransfers():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/get-incoming-transfers`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

   /**
   * Get outgoing transfers
   * @returns Array
   */
   public getOutgoingTransfers():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/get-outgoing-transfers`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get this week's transfers
   * @returns Array
   */
   public getThisWeekTransfers():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/get-current-week-transfers`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get Weekly Sales (list of units sold)
   * @returns Array
   */
  getWeeklySales(salesPeriodFilter:string): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/branch-manager/get-weekly-sales/${salesPeriodFilter}`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }
}
